import { ButtonGroupProps } from 'react-multi-carousel';
import { rem } from 'polished';

import styled from 'styled-components';
import useTranslations from '@hooks/useTranslations';

interface ArrowIconInterface {
    width?: number;
    height?: number;
    altText?: string;
    altId?: string;
}

export const ArrowIcon: React.FC<ArrowIconInterface> = ({ width, height, altText, altId }) => {
    return (
        <svg
            aria-labelledby={altId}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 13.503 23.619"
        >
            {altId && altText && <title id={altId}>{altText}</title>}
            <path
                d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z"
                transform="translate(-11.251 -6.194)"
            />
        </svg>
    );
};

const ButtonGroup = ({ next, previous, carouselState, ...rest }: ButtonGroupProps) => {
    const { t } = useTranslations();
    const { totalItems, currentSlide, slidesToShow } = carouselState;

    return (
        <Container className="carousel-button-group">
            <button
                disabled={currentSlide === 0}
                className="back-btn"
                onClick={() => previous()}
                data-testid={'TESTING_IMG_BACK_BUTTON'}
            >
                <ArrowIcon width={10} altId="previousButton" altText={t('carGallery.previousButton.desc')} />
            </button>
            <button
                disabled={currentSlide === totalItems - slidesToShow}
                className="next-btn"
                onClick={() => next()}
                data-testid={'TESTING_IMG_NEXT_BUTTON'}
            >
                <ArrowIcon width={10} altId="nextButton" altText={t('carGallery.nextButton.desc')} />
            </button>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    transform: translateX(-50%);

    .next-btn,
    .back-btn {
        display: flex;
    }

    .next-btn {
        svg {
            transform: rotate(180deg);
            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .back-btn {
        svg {
            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    button {
        background: none;
        border: none;
        width: fit-content;
        cursor: pointer;
        &:focus-visible {
            box-shadow: none;
            outline: none;
        }

        &:disabled {
            opacity: 0.5;
        }
    }
`;

export default ButtonGroup;
